var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeePassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 13.417,
    viewBox: "0 0 23 13.417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "see_password",
    transform: "translate(0 -65.924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2137",
    "data-name": "Group 2137",
    transform: "translate(8.649 69.782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2136",
    "data-name": "Group 2136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8576",
    "data-name": "Path 8576",
    d: "M198.111,192.682a.479.479,0,1,0-.678.678,2.875,2.875,0,1,1-4.065,4.065.479.479,0,1,0-.678.678,3.833,3.833,0,1,0,5.42-5.42Z",
    transform: "translate(-192.55 -192.542)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2139",
    "data-name": "Group 2139",
    transform: "translate(7.666 68.799)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2138",
    "data-name": "Group 2138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8577",
    "data-name": "Path 8577",
    d: "M175.169,170.725a3.8,3.8,0,0,0-4.5,3.767,3.751,3.751,0,0,0,.067.668.48.48,0,0,0,.471.4.423.423,0,0,0,.084-.008.48.48,0,0,0,.388-.555,2.78,2.78,0,0,1-.052-.5A2.84,2.84,0,0,1,175,171.668a.479.479,0,1,0,.167-.943Z",
    transform: "translate(-170.668 -170.659)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2141",
    "data-name": "Group 2141",
    transform: "translate(5.994 67.263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2140",
    "data-name": "Group 2140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8578",
    "data-name": "Path 8578",
    d: "M150.327,141.521a23.278,23.278,0,0,0-6.276-5.006.479.479,0,0,0-.44.852,22.518,22.518,0,0,1,5.707,4.464c-1.142,1.237-5.638,5.75-10.377,5.75a11.049,11.049,0,0,1-4.818-1.155.479.479,0,1,0-.416.862,11.983,11.983,0,0,0,5.234,1.251c5.9,0,11.165-6.137,11.387-6.4a.479.479,0,0,0,0-.618Z",
    transform: "translate(-133.435 -136.461)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2143",
    "data-name": "Group 2143",
    transform: "translate(0 65.924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2142",
    "data-name": "Group 2142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8579",
    "data-name": "Path 8579",
    d: "M14.644,107.211a9.894,9.894,0,0,0-3.144-.552c-5.9,0-11.165,6.137-11.387,6.4a.479.479,0,0,0-.027.584,17.79,17.79,0,0,0,4.4,4.168.479.479,0,0,0,.529-.8,17.524,17.524,0,0,1-3.915-3.62c1.1-1.2,5.628-5.776,10.4-5.776a8.971,8.971,0,0,1,2.839.5.473.473,0,0,0,.607-.3.478.478,0,0,0-.3-.606Z",
    transform: "translate(0 -106.659)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeePassword);
export default __webpack_public_path__ + "static/media/see_password.f18506ca18ac48ec821bbdb86e6749ca.svg";
export { ForwardRef as ReactComponent };